export const onReady = (callback) => {
  if (document.readyState != "loading") {
    callback()
  } else if (document.addEventListener) {
    document.addEventListener("DOMContentLoaded", callback)
  } else {
    document.attachEvent("onreadystatechange", function () {
      if (document.readyState == "complete") callback()
    })
  }
}

const camelCase = (str) => {
  return str.replace(/-([a-z])/g, (g) => g[1].toUpperCase())
}

export const getData = (element, key) => {
  const value = element.dataset[camelCase(key)]

  // Return undefined for missing attributes (jQuery behavior)
  if (value === undefined) return undefined

  // jQuery normalization behavior
  if (value === "true") return true
  if (value === "false") return false
  if (value === "null") return null
  if (value === "") return ""

  // Convert numeric strings to numbers
  if (!isNaN(value) && value !== "" && value.trim() !== "") {
    return Number(value)
  }

  // Try to parse JSON (arrays/objects)
  if (value?.startsWith("[") || value?.startsWith("{")) {
    try {
      return JSON.parse(value)
    } catch {
      return value
    }
  }

  return value
}
